import { getEncarteThemeSearchResult } from "../../../../../services/EncarteThemeService";

const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;
/**
 * Fetch themes recommended for today.
 * @param {string} token - Auth token
 * @param {number} page - Page number (default 0)
 * @param {number} size - Page size (default 10)
 * @returns {Promise<Page<EncarteTheme>>}
 */
export default function useFetchTodayThemes() {
  const fetchTodayThemes = async (token, page = 0, size = 10) => {
    const url = `${BASE_URL}/encartethemes/today?page=${page}&size=${size}`;
    const res = await fetch(url, {
      headers: { Authorization: token },
    });
    if (!res.ok) throw new Error("Failed to fetch today's themes");
    const json = await res.json();
    return getEncarteThemeSearchResult(token, json);
  };
  return fetchTodayThemes;
}
